// extracted by mini-css-extract-plugin
export default {"saleprice":"SaleItems_saleprice__Se8hS","fakprice":"SaleItems_fakprice__2KeWL"};